import { render } from "./MasterSkuDetail.vue?vue&type=template&id=790bdbd5&scoped=true"
import script from "./MasterSkuDetail.vue?vue&type=script&lang=js"
export * from "./MasterSkuDetail.vue?vue&type=script&lang=js"

import "./MasterSkuDetail.vue?vue&type=style&index=0&id=790bdbd5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790bdbd5"]])

export default __exports__